import { differenceInCalendarDays, startOfDay } from 'date-fns';
import { getTransferDisplayAtIso } from '../inventory-transfers/transferDisplayDate';
import type { InventoryItem } from '../../types/inventory';

/**
 * Días calendario desde llegada a sucursal (recepción) hasta hoy.
 * Prefer receivedAt; fallback firstAssignedAt (compat mirror).
 * Do not use transferredAt (envío) — that is "Fecha Transfer." only.
 */
export function calendarDaysSinceInventoryTransfer(item: InventoryItem): number | null {
  const iso =
    (item.receivedAt != null && item.receivedAt !== '' ? item.receivedAt : null) ??
    item.firstAssignedAt ??
    getTransferDisplayAtIso(item.transfer, item.firstAssignedAt, item.transferredAt) ??
    null;
  if (!iso) return null;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  const anchor = startOfDay(d);
  const today = startOfDay(new Date());
  return differenceInCalendarDays(today, anchor);
}

/**
 * Días calendario desde la fecha de registro (REG completado / createdAt mapeado) hasta hoy.
 */
export function calendarDaysSinceRegistration(item: InventoryItem): number | null {
  const iso = item.createdAt;
  if (iso == null || iso === '') return null;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  const anchor = startOfDay(d);
  const today = startOfDay(new Date());
  return differenceInCalendarDays(today, anchor);
}
